module.exports = "<div class=\"thank-you\">\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/thankYou/thankYou.html
// module id = ./src/app/thankYou/thankYou.html
// module chunks = main